
import {useEffect} from 'react'

export const Hotjar = (props) => {
  useEffect(() => {
    if (props.hotjarId) {
      window.hj = window.hj || function () { (window.hj.q = window.hj.q || []).push(arguments) }
      window._hjSettings = { hjid: props.hotjarId, hjsv: 6 }
      const head = document.getElementsByTagName('head')[0]
      let hotjarScript = document.createElement('script')
      hotjarScript.async = 1
      hotjarScript.src = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`
      head.appendChild(hotjarScript)
    }
  }, [])

  return null
}
